require("core-js/modules/es.array.index-of");

require("core-js/modules/es.array.slice");

require("core-js/modules/es.array.some");

require("core-js/modules/es.array.splice");

require("core-js/modules/es.regexp.exec");

require("core-js/modules/es.string.replace");

require("core-js/modules/es.string.split");

(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "vant/es/dialog/style", "vant/es/dialog", "vant/es/toast/style", "vant/es/toast", "vant/es/icon/style", "vant/es/icon"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("vant/es/dialog/style"), require("vant/es/dialog"), require("vant/es/toast/style"), require("vant/es/toast"), require("vant/es/icon/style"), require("vant/es/icon"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.style, global.dialog, global.style, global.toast, global.style, global.icon);
    global.barcodeBindList = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _style, _dialog, _style2, _toast, _style3, _icon) {
  "use strict";

  var _interopRequireDefault = require("/root/deploy/iot-product-tool/node_modules/@babel/runtime/helpers/interopRequireDefault");

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  _dialog = _interopRequireDefault(_dialog);
  _toast = _interopRequireDefault(_toast);
  _icon = _interopRequireDefault(_icon);
  var _default = {
    name: 'XiazengBarcodeBindList',
    components: {
      Icon: _icon.default
    },
    data: function data() {
      var _this$$config$base = this.$config.base,
          ossHost = _this$$config$base.ossHost,
          ossHostPond = _this$$config$base.ossHostPond;
      return {
        ossHost: ossHost,
        ossPondHost: ossHostPond,
        list: [],
        submitting: false,
        showAddDialog: false,
        showBatchPicker: false,
        addForm: {
          uniqueId: '',
          barcode: '',
          // 批次ID，提交时使用
          batchId: '',
          // 展示名
          batchName: '',
          // 真实批次号，提交时使用
          batchNo: ''
        },
        batchList: []
      };
    },
    created: function created() {
      this.weixinInit();
      this.loadBatchList();
    },
    beforeRouteLeave: function beforeRouteLeave(to, from, next) {
      // 退出到 index 页时清空数据，下次进入重新开始
      if (to.path === '/xiazeng/index') {
        this.list = [];
        this.addForm = {
          uniqueId: '',
          barcode: '',
          batchId: '',
          batchName: '',
          batchNo: ''
        };
        this.showAddDialog = false;
        this.showBatchPicker = false;
      }

      next();
    },
    methods: {
      // 微信 JSSDK 初始化
      weixinInit: function weixinInit() {
        var vm = this;
        vm.$http({
          method: 'GET',
          url: "https://m.yudada.com/jssdk/configuration?url=".concat(location.href)
        }).then(function (res) {
          var _res$data = res.data,
              appId = _res$data.appId,
              nonceStr = _res$data.nonceStr,
              signature = _res$data.signature,
              timestamp = _res$data.timestamp;
          window.wx.config({
            debug: false,
            appId: appId,
            timestamp: timestamp,
            nonceStr: nonceStr,
            signature: signature,
            jsApiList: ['scanQRCode']
          });
        });
      },
      // 加载批次号列表
      loadBatchList: function loadBatchList() {
        var vm = this;
        vm.$http({
          method: 'GET',
          url: vm.$config.base.XIAZENG_BASE_URL + 'xia/factory/batch/active'
        }).then(function (res) {
          var batchList = Array.isArray(res.data) ? res.data : [];
          vm.batchList = batchList; // 默认选第一个

          if (batchList.length && !vm.addForm.batchName) {
            vm.addForm.batchId = batchList[0].id;
            vm.addForm.batchName = batchList[0].batchName;
            vm.addForm.batchNo = batchList[0].batchNo;
          }
        }).catch(function () {});
      },
      // 选择批次号
      onSelectBatch: function onSelectBatch(item) {
        this.addForm.batchId = item.id;
        this.addForm.batchName = item.batchName;
        this.addForm.batchNo = item.batchNo;
        this.showBatchPicker = false;
      },
      // 扫码获取设备号（二维码 -> 解析接口 -> 8位 uniqueId）
      onclickScanDevice: function onclickScanDevice() {
        var vm = this;

        if (window.wx && window.wx.scanQRCode) {
          window.wx.scanQRCode({
            needResult: 1,
            scanType: ['qrCode'],
            success: function success(res) {
              var result = res.resultStr;

              if (!(result && result.split('deviceId=')[1])) {
                (0, _toast.default)('编号错误，请确认后重试');
                return;
              }

              var encodeId = result.split('deviceId=')[1];
              vm.$http({
                method: 'GET',
                url: vm.$config.base.PROBE_BASE_URL + "device/info?encodeId=".concat(encodeId)
              }).then(function (rs) {
                vm.addForm.uniqueId = rs.data.uniqueId;
              });
            }
          });
        } else {
          (0, _toast.default)('请在微信中扫码');
        }
      },
      // 扫码获取条形码
      onclickScanBarcode: function onclickScanBarcode() {
        var vm = this;

        if (window.wx && window.wx.scanQRCode) {
          window.wx.scanQRCode({
            needResult: 1,
            scanType: ['barCode'],
            success: function success(res) {
              // 条形码扫码结果格式为 "条码类型,条码内容"，如 CODE_128,123456，截取第一个逗号后的内容
              var result = res.resultStr || '';
              var commaIndex = result.indexOf(',');

              if (commaIndex > -1) {
                result = result.slice(commaIndex + 1);
              }

              vm.addForm.barcode = result;
            }
          });
        } else {
          (0, _toast.default)('请在微信中扫码');
        }
      },
      // 关闭弹框
      closeDialog: function closeDialog() {
        this.showAddDialog = false;
      },
      // 点击批次号字段
      onclickBatchField: function onclickBatchField() {
        if (!this.batchList.length) return;
        this.showBatchPicker = true;
      },
      // 确认添加设备到列表
      onclickConfirmAdd: function onclickConfirmAdd() {
        var vm = this;

        if (!vm.batchList.length) {
          (0, _toast.default)('暂无批次号，无法添加设备');
          return;
        }

        if (!vm.addForm.uniqueId) {
          (0, _toast.default)('请扫码录入设备号');
          return;
        }

        if (!vm.addForm.barcode) {
          (0, _toast.default)('请扫码录入条形码');
          return;
        }

        if (!vm.addForm.batchNo) {
          (0, _toast.default)('请选择批次号');
          return;
        } // 检查是否已存在相同设备


        var exists = vm.list.some(function (item) {
          return item.uniqueId === vm.addForm.uniqueId;
        });

        if (exists) {
          (0, _toast.default)('该设备已在列表中');
          return;
        }

        vm.list.push({
          uniqueId: vm.addForm.uniqueId,
          barcode: vm.addForm.barcode,
          batchId: vm.addForm.batchId,
          batchName: vm.addForm.batchName,
          batchNo: vm.addForm.batchNo
        });
        vm.addForm = {
          uniqueId: '',
          barcode: '',
          batchId: vm.addForm.batchId,
          batchName: vm.addForm.batchName,
          batchNo: vm.addForm.batchNo
        };
        vm.showAddDialog = false;
        (0, _toast.default)('录入成功，您可继续扫码录入下一台设备');
      },
      // 移除设备
      onclickRemoveBtn: function onclickRemoveBtn(index) {
        this.list.splice(index, 1);
      },
      // 点击提交按钮 - 二次确认后逐台提交
      onclickSubmitBtn: function onclickSubmitBtn() {
        var vm = this;
        if (!vm.list.length || vm.submitting) return;

        _dialog.default.confirm({
          title: '是否确认提交',
          message: '提交后设备号将关联条形码，且无法二次修改',
          confirmButtonText: '确 认',
          cancelButtonText: '取 消'
        }).then(function () {
          vm.doSubmitAll();
        }).catch(function () {});
      },
      // 逐台轮询提交
      doSubmitAll: function doSubmitAll() {
        var vm = this;
        var submitList = vm.list.slice();
        vm.submitting = true;

        var toast = _toast.default.loading({
          message: '提交中...',
          forbidClick: true,
          duration: 0
        });

        var index = 0;

        var submitNext = function submitNext() {
          if (index >= submitList.length) {
            toast.clear();
            vm.submitting = false;
            (0, _toast.default)('提交成功');
            vm.list = [];
            vm.addForm = {
              uniqueId: '',
              barcode: '',
              batchId: '',
              batchName: '',
              batchNo: ''
            };
            vm.$router.replace({
              path: '/xiazeng/index'
            });
            return;
          }

          var item = submitList[index];
          vm.$http({
            method: 'POST',
            url: vm.$config.base.XIAZENG_BASE_URL + 'xia/factory/bindBarcode',
            params: {
              batchId: item.batchId,
              uniqueId: item.uniqueId,
              barcode: item.barcode
            }
          }).then(function () {
            index++;
            submitNext();
          }).catch(function () {
            toast.clear();
            vm.submitting = false;
            (0, _toast.default)("\u8BBE\u5907".concat(item.uniqueId, "\u63D0\u4EA4\u5931\u8D25"));
          });
        };

        submitNext();
      },
      // 跳转关联记录页
      onclickRecordBtn: function onclickRecordBtn() {
        this.$router.push({
          path: './barcodeBindRecord'
        });
      }
    }
  };
  _exports.default = _default;
});